import { COLORS } from 'helpers/globals'
import { list, third, listItem, selected } from 'components/CameraModelSelector/style'

const star = {
  color: COLORS.gold,
  fontSize: '1.9rem',
  marginLeft: '.3rem'
}

export default {
  CameraList: {
    ...third,
    width: ({ lensSelector }) => lensSelector ? '50%' : '33%'
  },
  list: {
    ...list,
    borderLeft: ({ lensSelector }) => lensSelector ? `1px solid ${COLORS.quaternary}` : 'none'
  },
  listItemOdd: {
    ...listItem,
    background: 'white !important'
  },
  listItemEven: {
    ...listItem,
    background: `${COLORS.tertiary} !important`
  },
  selected,
  NoMatch: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '2rem',
    textAlign: 'center',
    fontSize: '1.9rem',
    color: 'black',
    position: 'relative'
  },
  line1: {
    marginBottom: '2rem',
    fontStyle: 'italic'
  },
  line2: {
    fontWeight: 'bold',
    marginBottom: '2rem'
  },
  missingCameraLink: {
    fontSize: '1.8rem',
    fontWeight: 400,
    color: 'white',
    background: COLORS.primary,
    padding: '.4rem .8rem',
    borderRadius: '.5rem',
    '&:hover': {
      color: 'white',
      background: COLORS.primaryHover
    }
  },
  cameraModel: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    flex: 1
  },
  star,
  clock: {
    ...star,
    color: COLORS.secondary,
    marginRight: '.2rem'
  },
  eolSpan: {
    color: 'white',
    background: 'red',
    fontSize: '1.4rem',
    fontWeight: '500',
    lineHeight: 0,
    borderRadius: '.5rem',
    padding: '1rem .5rem',
    marginLeft: '.7rem'
  },
  resetButton: {
    background: '#D53032',
    color: 'white',
    fontWeight: '400',
    borderRadius: 2,
    padding: '.75rem 3rem',
    margin: '0 auto 2rem auto',
    display: 'inline-block',
    '&:hover': {
      background: '#FF6365',
      color: 'white',
      cursor: 'pointer'
    }
  },
  resetIcon: {
    fontSize: '2.4rem',
    marginRight: '.5rem',
    verticalAlign: '-.5rem'
  },
  break: {
    margin: '0 5% 2rem 5% !important',
    width: '90%'
  }
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraList/style.js